import React, { useState, useEffect } from "react";
import { Form, Input, Button, Upload, message, Table, Tag, Select, Col, Row, Collapse, Tabs, Modal, InputNumber } from "antd";
import { UploadOutlined, DownloadOutlined } from "@ant-design/icons";
import { Editor } from "@tinymce/tinymce-react";
import courseService from "../../services/course.service";
import TabPane from "antd/es/tabs/TabPane";
import dayjs from "dayjs";

const TrainingForm = ({ courseId }) => {

    const [file, setFile] = useState(null);
    const [editorContent, setEditorContent] = useState("");
    const [form] = Form.useForm();
    const [trainings, setTrainings] = useState([]);
    const [gradeInputs, setGradeInputs] = useState({});
    const [loading, setLoading] = useState(false);
    const [editingExercise, setEditingExercise] = useState(null);
    const [courseElements, setCourseElements] = useState([]); // éléments plats
    const [courseStructure, setCourseStructure] = useState({ groups: [] }); // structure arborescente
    const [selectedElementType, setSelectedElementType] = useState("SUBJECT");
    const [structureLoading, setStructureLoading] = useState(true);
    const [activeTabKey, setActiveTabKey] = useState("1"); // onglet actif
    const tabsRef = React.useRef(); // pour pointer vers Tabs

    const [editingTrainingId, setEditingTrainingId] = useState(null);
    const [saving, setSaving] = useState(false); // pour le bouton Enregistrer


    // ✅ ICI : juste après les useState
    //    const extractTrainingsFromStructure = (structure) => {
    //     return structure.groups
    //         .filter(group => group.elementType === "TRAINING" && Array.isArray(group.trainings) && group.trainings.length > 0)
    //         .map(group => {
    //             const training = group.trainings[0];
    //             return {
    //                 title: group.title,
    //                 id: training.id,
    //                 exercises: training.exercises || []
    //             };
    //         });
    // };
    const extractTrainingsFromStructure = (structure) => {

        const seen = new Set();
        return structure.groups
            .filter(group => group.elementType === "TRAINING" && Array.isArray(group.trainings))
            .flatMap(group =>
                group.trainings
                    .filter(training => {
                        if (seen.has(training.id)) return false;
                        seen.add(training.id);
                        return true;
                    })
                    .map(training => ({
                        title: training.title || group.title,
                        id: training.id,
                        percentage: training.percentage, // ✅ AJOUT ICI

                        exercises: training.exercises || []
                    }))
            );
    };




    const renderTrainingList = () => {



        const handleDeleteTraining = (trainingId) => {
            Modal.confirm({
                title: "Confirmer la suppression",
                content: "Voulez-vous vraiment supprimer ce bloc d'entraînement ?",
                okText: "Oui, supprimer",
                okType: "danger",
                cancelText: "Annuler",
                onOk: async () => {
                    try {
                        await courseService.deleteTrainingBloc(trainingId);
                        message.success("Bloc supprimé !");
                        const updatedStructure = await courseService.getCourseStructure(courseId);
                        setCourseStructure(updatedStructure);
                    } catch (error) {
                        message.error("Erreur lors de la suppression.");
                    }
                }
            });
        };



        // ...


        // const handleEditTraining = (training) => {
        //     alert("training " + JSON.stringify(training.id))
        //   message.success("Entraînement à modifier !");
        //   setActiveTabKey("1"); // aller à l'onglet 'Nouveau'
        //   form.setFieldsValue({
        //     trainingTitle: training.title,
        //     title: training.exercises?.[0]?.title ?? "",
        //     elementType: "TRAINING",
        //     referenceElementId: training.id,
        //     positioning: "AFTER", // ou BEFORE selon ton cas
        //   });



        //   setEditorContent(training.exercises?.[0]?.instructionsText ?? "");

        //   // Si le fichier modèle existe, on peut ajouter un tag ou info
        //   if (training.exercises?.[0]?.templateFileUrl) {
        //     message.info("Un fichier modèle est déjà associé à cet exercice.");
        //   }

        //   setEditingExercise(training.exercises?.[0]); // mettre à jour l'état
        // };

        const handleEditTraining = (training) => {
            message.success("Entraînement à modifier !");
            setActiveTabKey("1"); // Aller à l'onglet 'Nouveau'

            form.setFieldsValue({
                trainingTitle: training.title,
                title: training.exercises?.[0]?.title ?? "",
                percentage: training.percentage ?? 0,
                elementType: "TRAINING",
                referenceElementId: training.id,
                positioning: "AFTER",
            });

            setEditorContent(training.exercises?.[0]?.instructionsText ?? "");

            if (training.exercises?.[0]?.templateFileUrl) {
                message.info("Un fichier modèle est déjà associé à cet exercice.");
            }

            setEditingExercise(training.exercises?.[0]);   // l'exercice
            setEditingTrainingId(training.id);             // ✅ bloc d'entraînement
        };


        console.log("courseStructure inside renderTrainingList: ", courseStructure);

        if (!courseStructure.groups || courseStructure.groups.length === 0) {
            return <Tag color="warning">Structure du cours non encore chargée</Tag>;
        }

        const trainingsData = extractTrainingsFromStructure(courseStructure);
        console.log("🔍 trainingsData rendus :", trainingsData);

        return (
            <Collapse accordion>
                {trainingsData.map(training => (
                    <Panel header={training.title} key={training.id}>
                        {training.exercises.length > 0 ? (
                            // training.exercises.map(ex => (
                            //     <div key={ex.id} style={{ marginBottom: 10 }}>
                            //         <b>{ex.title}</b>
                            //         <p dangerouslySetInnerHTML={{ __html: ex.instructionsText }} />
                            //         {ex.templateFileUrl && (
                            //             <a href={ex.templateFileUrl} target="_blank" rel="noopener noreferrer">
                            //                 <DownloadOutlined /> Fichier modèle
                            //             </a>
                            //         )}
                            //         {ex.studentFileUrl && (
                            //             <div>
                            //                 <br />
                            //                 <a href={ex.studentFileUrl} target="_blank" rel="noopener noreferrer">
                            //                     <DownloadOutlined /> Fichier étudiant
                            //                 </a>
                            //             </div>
                            //         )}
                            //     </div>
                            // ))
                            <Row gutter={[16, 16]}>
                                {training.exercises.map((ex) => (
                                    // <Col span={24} key={ex.id}>
                                    //     <div style={{
                                    //         border: "1px solid #f0f0f0",
                                    //         borderRadius: 8,
                                    //         padding: 16,
                                    //         backgroundColor: "#fafafa",
                                    //         boxShadow: "0 2px 8px rgba(0,0,0,0.05)"
                                    //     }}>
                                    //         <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    //             <div>
                                    //                 <b style={{ fontSize: 16 }}>
                                    //                     📝 {ex.title}
                                    //                 </b>
                                    //             </div>
                                    //             {ex.percentage !== undefined && (
                                    //                 <Tag color="blue" style={{ fontSize: 14 }}>
                                    //                     🎯 Objectif : {ex.percentage}%
                                    //                 </Tag>
                                    //             )}
                                    //         </div>

                                    //         <div style={{ marginTop: 8 }} dangerouslySetInnerHTML={{ __html: ex.instructionsText }} />

                                    //         <div style={{ marginTop: 10 }}>
                                    //             {ex.templateFileUrl ? (
                                    //                 <a href={ex.templateFileUrl} target="_blank" rel="noopener noreferrer">
                                    //                     📎 <DownloadOutlined /> Fichier modèle
                                    //                 </a>
                                    //             ) : (
                                    //                 <Tag color="red">⚠️ Aucun fichier modèle</Tag>
                                    //             )}
                                    //         </div>

                                    //         {ex.studentFileUrl && (
                                    //             <div style={{ marginTop: 8 }}>
                                    //                 <a href={ex.studentFileUrl} target="_blank" rel="noopener noreferrer">
                                    //                     📤 <DownloadOutlined /> Fichier étudiant
                                    //                 </a>
                                    //             </div>
                                    //         )}
                                    //     </div>
                                    // </Col>
                                    <Col span={24} key={ex.id}>
                                        <div style={{
                                            border: "1px solid #d9d9d9",
                                            borderRadius: 10,
                                            padding: 20,
                                            backgroundColor: "#fff",
                                            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                                            marginBottom: 16
                                        }}>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <div style={{ fontWeight: 'bold', fontSize: 18 }}>
                                                    📝 {ex.title}
                                                </div>
                                                {ex.grade !== null && (
                                                    <Tag color="green">✅ Noté : {ex.grade}/20</Tag>
                                                )}
                                            </div>

                                            <div style={{ marginTop: 8, color: "#555" }}>
                                                <div dangerouslySetInnerHTML={{ __html: ex.instructionsText }} />
                                            </div>

                                            <div style={{ marginTop: 12 }}>
                                                {ex.templateFileUrl ? (
                                                    <a href={ex.templateFileUrl} target="_blank" rel="noopener noreferrer">
                                                        📎 <DownloadOutlined /> Fichier modèle
                                                    </a>
                                                ) : (
                                                    <Tag color="red">⚠️ Aucun fichier modèle</Tag>
                                                )}
                                            </div>

                                            {ex.studentFileUrl && (
                                                <div style={{ marginTop: 8 }}>
                                                    <a href={ex.studentFileUrl} target="_blank" rel="noopener noreferrer">
                                                        📤 <DownloadOutlined /> Fichier étudiant
                                                    </a>
                                                </div>
                                            )}

                                            {training.percentage !== undefined && (
                                                <div style={{ marginTop: 12 }}>
                                                    <Tag color="blue">🎯 Objectif : {training.percentage}%</Tag>
                                                </div>
                                            )}
                                        </div>
                                    </Col>

                                ))}
                            </Row>

                        ) : (
                            <Tag color="orange">Aucun exercice</Tag>
                        )}
                        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px' }}>
                            <Button danger onClick={() => handleDeleteTraining(training.id)}>
                                Supprimer
                            </Button>
                            <Button type="primary" onClick={() => handleEditTraining(training)}>
                                Modifier
                            </Button>
                        </div>
                    </Panel>
                ))}
            </Collapse>
        );
    };



    const fetchElementsByType = async (type) => {
        if (type !== "SUBJECT") {
            setCourseElements([]); // vider la liste si ce n'est pas un sujet
            return;
        }

        try {
            const elements = await courseService.Getgroupnames(courseId);
            console.log("Groupes récupérés :", elements);
            setCourseElements(Array.isArray(elements) ? elements : []);
        } catch (err) {
            message.error("Erreur chargement des groupes");
        }
    };


    useEffect(() => {
        console.log("📦 Nouvelle structure chargée :", courseStructure);
    }, [courseStructure]);

    useEffect(() => {
        const fetchStructure = async () => {
            try {
                const data = await courseService.getCourseStructure(courseId);
                // alert("data : " + JSON.stringify(data))
                setCourseStructure(data);
            } catch (err) {
                message.error("Erreur chargement structure du cours");
            } finally {
                setStructureLoading(false);
            }
        };

        fetchStructure();
        fetchElementsByType("SUBJECT"); // 👈 Charger uniquement les éléments de type SUBJECT au démarrage
    }, [courseId]);


    // const fetchTrainings = async () => {
    //     try {
    //         setLoading(true);
    //         const data = await courseService.getTrainingExercisesByCourse(courseId);
    //         setTrainings(data);
    //     } catch (error) {
    //         message.error("Impossible de charger les exercices.");
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const fetchTrainings = async () => {
        try {
            setLoading(true);
            const data = await courseService.getTrainingExercisesByCourseByUser(courseId);
            console.log("data of users  : " + JSON.stringify(data))
            setTrainings(data);
        } catch (error) {
            message.error("Impossible de charger les exercices.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTrainings();
    }, [courseId]);

    const handleEdit = (record) => {
        // alert("je suis dans le bloc")
        // alert("record" + record)
        form.setFieldsValue({
            title: record.title,
            percentage: record.percentage ?? 0, // 👈 Ajouter ceci aussi ici
        });
        setEditorContent(record.instructionsText);
        setEditingExercise(record);
    };

    const handleDelete = async (id) => {
        try {
            await courseService.deleteTrainingExercise(id);
            message.success("Exercice supprimé !");
            fetchTrainings();
        } catch (err) {
            message.error("Erreur lors de la suppression.");
        }
    };

    /// old code befor integrate update position of my entrainenemt 
    // const handleSubmit = async (values) => {
    //     try {
    //         // const { title, elementType, referenceElementId, positioning } = values;
    //         const { title, trainingTitle, elementType, referenceElementId, positioning } = values;

    //         if (editingExercise) {
    //             await courseService.updateExercise(editingExercise.id, title, editorContent);
    //             message.success("Exercice mis à jour !");
    //             setEditingExercise(null);
    //         } else {
    //             if (!file) {
    //                 message.warning("Veuillez sélectionner un fichier.");
    //                 return;
    //             }

    //             await courseService.uploadTrainingExerciseWithPositioning(
    //                 courseId,
    //                 {
    //                     title,
    //                     trainingTitle, // ✅ à envoyer !

    //                     instructionsText: editorContent,
    //                     elementType,
    //                     referenceElementId,
    //                     positioning
    //                 },
    //                 file
    //             );

    //             message.success("Exercice d'entraînement ajouté !");
    //         }

    //         fetchTrainings();
    //     } catch (err) {
    //         message.error("Erreur lors de l'enregistrement de l'exercice.");
    //     }
    // };

    const resetFormAndReload = async () => {
        form.resetFields();                // Vide le formulaire
        setFile(null);                     // Réinitialise le fichier
        setEditorContent("");             // Vide l'éditeur
        setEditingExercise(null);         // Supprime l'état d'édition
        setEditingTrainingId(null);       // Supprime l'ID d'entraînement édité
        setGradeInputs({});               // Réinitialise les notes
        setSelectedElementType("SUBJECT"); // Réinitialise le type
        setSaving(false);
        setActiveTabKey("1");             // Retour à l'onglet "Nouveau"

        try {
            setStructureLoading(true);
            const structure = await courseService.getCourseStructure(courseId);
            setCourseStructure(structure);

            fetchElementsByType("SUBJECT"); // recharge les éléments de positionnement
            fetchTrainings();               // recharge la table des exercices
        } catch (err) {
            message.error("Erreur lors du rafraîchissement.");
        } finally {
            setStructureLoading(false);
        }
    };

    const handleSubmit = async (values) => {
        try {
            setSaving(true); // start loading

            const {
                title,
                trainingTitle,
                elementType,
                referenceElementId,
                positioning,
                percentage
            } = values;

            // Conversion sécurisée de referenceElementId
            const refIdNumber = referenceElementId ? Number(referenceElementId) : null;

            // Construction du payload commun
            const payload = {
                title,
                trainingTitle,
                instructionsText: editorContent,
                elementType,
                referenceElementId: refIdNumber,
                positioning,
                percentage: Number(percentage) // sécurise la conversion

            };

            if (editingExercise) {
                // 🔍 Extraction + conversion sécurisée
                const {
                    title,
                    trainingTitle,
                    instructionsText,
                    elementType,
                    referenceElementId,
                    positioning,

                } = values;

                const payload = {
                    title,
                    trainingTitle,
                    instructionsText: editorContent, // 📝 contenu de l'éditeur
                    elementType,
                    referenceElementId: Number(referenceElementId), // ✅ important
                    positioning,
                    percentage: Number(percentage)

                };

                // 🛠️ Log clair pour debug
                console.log("📦 Données envoyées pour modification :", {
                    id: editingExercise.trainingId || editingExercise.id,
                    payload,
                    file
                });

                //   alert(" editingExercise.trainingId " +  JSON.stringify(editingExercise))
                //     alert(" editingExercise.id" +  editingExercise.id)

                // ✅ Envoi vers API
                await courseService.updateTrainingExerciseWithPositioning(
                    editingTrainingId,
                    payload,
                    file
                );


                message.success("Entraînement mis à jour !");
                setEditingExercise(null);
            }
            else {
                if (!file) {
                    message.warning("Veuillez sélectionner un fichier.");
                    return;
                }

                await courseService.uploadTrainingExerciseWithPositioning(
                    courseId,
                    payload,
                    file
                );

                message.success("Exercice d'entraînement ajouté !");
            }

            fetchTrainings();
        } catch (err) {
            console.error("❌ Erreur handleSubmit :", err);
            message.error("Erreur lors de l'enregistrement de l'exercice.");
        } finally {
            setSaving(false); // end loading
        }
    };


    // const transformedData = trainings.flatMap(training =>
    //     training.responses.map(response => ({
    //         id: response.id,
    //         trainingExerciseId: training.trainingExerciseId,
    //         title: training.title,
    //         username: response.username,
    //         email: response.email,
    //         studentFileUrl: response.studentFileUrl,
    //         templateFileUrl: training.templateFileUrl,
    //         grade: response.grade,
    //         submittedAt: response.submittedAt
    //     }))
    // );

    const transformedData = trainings.flatMap(training =>
        training.responses.map(response => ({
            id: response.id,
            trainingExerciseId: training.trainingExerciseId,
            title: training.title,
            username: response.username,
            email: response.email,
            studentFileUrl: response.studentFileUrl,
            templateFileUrl: training.templateFileUrl,
            grade: response.grade,
            submittedAt: response.submittedAt
        }))
    );




    // const columns = [
    //     {
    //         title: "Titre",
    //         dataIndex: "title",
    //         key: "title",
    //         render: text => <b>{text}</b>
    //     },
    //     {
    //         title: "Note",
    //         key: "grade",
    //         render: (record) => (
    //             <div style={{ display: "flex", gap: 8 }}>
    //                 <Input
    //                     type="number"
    //                     value={gradeInputs[record.id] ?? record.grade ?? 0}
    //                     style={{ width: 80 }}
    //                     onChange={(e) => {
    //                         const val = e.target.value;
    //                         setGradeInputs((prev) => ({
    //                             ...prev,
    //                             [record.id]: val
    //                         }));
    //                     }}
    //                 />
    //                 <Button
    //                     type="primary"
    //                     size="small"
    //                     onClick={async () => {
    //                         const grade = parseFloat(gradeInputs[record.id]);
    //                         if (!isNaN(grade)) {
    //                             try {
    //                                 await courseService.updateTrainingGrade(record.id, grade);
    //                                 message.success("Note mise à jour !");
    //                                 fetchTrainings();
    //                             } catch (err) {
    //                                 message.error("Erreur lors de la mise à jour de la note");
    //                             }
    //                         }
    //                     }}
    //                 >
    //                     Valider
    //                 </Button>
    //             </div>
    //         )
    //     },
    //     {
    //         title: "Fichier modèle",
    //         dataIndex: "templateFileUrl",
    //         key: "templateFileUrl",
    //         render: (url) =>
    //             url ? (
    //                 <a href={url} target="_blank" rel="noopener noreferrer">
    //                     <DownloadOutlined /> Modèle
    //                 </a>
    //             ) : (
    //                 <Tag color="red">Aucun</Tag>
    //             )
    //     },
    //     {
    //         title: "Fichier étudiant",
    //         dataIndex: "studentFileUrl",
    //         key: "studentFileUrl",
    //         render: (url) =>
    //             url ? (
    //                 <a href={url} target="_blank" rel="noopener noreferrer">
    //                     <DownloadOutlined /> Travail
    //                 </a>
    //             ) : (
    //                 <Tag color="gray">Non soumis</Tag>
    //             )
    //     },
    //     {
    //         title: "Action",
    //         key: "action",
    //         render: (_, record) => (
    //             <>
    //                 <Button danger onClick={() => handleDelete(record.id)}>Supprimer</Button>
    //                 <Button type="link" onClick={() => handleEdit(record)}>Modifier</Button>
    //             </>
    //         )
    //     }
    // ];
    const columns = [
        {
            title: "Titre Exercice",
            dataIndex: "title",
            key: "title",
            render: text => (
                <span style={{ fontWeight: "bold", color: "#1890ff" }}>
                    📘 {text}
                </span>
            )
        },
        {
            title: "Utilisateur",
            dataIndex: "username",
            key: "username",
            render: (name) => <Tag color="geekblue">👤 {name}</Tag>
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
            render: (email) => <Tag color="cyan">{email}</Tag>
        },
        {
            title: "Note",
            key: "grade",
            render: (record) => (
                <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                    <Input
                        type="number"
                        value={gradeInputs[record.id] ?? record.grade ?? 0}
                        style={{ width: 80 }}
                        min={0}
                        max={100}
                        onChange={(e) => {
                            const val = e.target.value;
                            setGradeInputs((prev) => ({
                                ...prev,
                                [record.id]: val
                            }));
                        }}
                    />
                    <Button
                        type="primary"
                        icon={<DownloadOutlined />}
                        onClick={async () => {
                            const grade = parseFloat(gradeInputs[record.id]);
                            if (!isNaN(grade)) {
                                try {
                                    await courseService.updateTrainingGrade(record.id, grade);
                                    message.success("✅ Note mise à jour !");
                                    fetchTrainings();
                                } catch (err) {
                                    message.error("❌ Erreur lors de la mise à jour");
                                }
                            }
                        }}
                    >
                        Valider
                    </Button>

                </div>
            )
        },
        {
            title: "Fichier modèle",
            dataIndex: "templateFileUrl",
            key: "templateFileUrl",
            render: (url) =>
                url ? (
                    <a href={url} target="_blank" rel="noopener noreferrer">
                        📥 <Tag color="blue">Modèle</Tag>
                    </a>
                ) : (
                    <Tag color="red">Aucun</Tag>
                )
        },
        {
            title: "Fichier étudiant",
            dataIndex: "studentFileUrl",
            key: "studentFileUrl",
            render: (url) =>
                url ? (
                    <a href={url} target="_blank" rel="noopener noreferrer">
                        📤 <Tag color="green">Travail</Tag>
                    </a>
                ) : (
                    <Tag color="gray">Non soumis</Tag>
                )
        },
        {
            title: "Date de soumission",
            dataIndex: "submittedAt",
            key: "submittedAt",
            render: (date) =>
                date ? (
                    <Tag color="purple">⏱ {dayjs(date).format("DD/MM/YYYY HH:mm")}</Tag>
                ) : (
                    <Tag color="gray">Non soumis</Tag>
                )
        }
    ];


    const columnsTrainings = [
        {
            title: "ID Exercice",
            dataIndex: "trainingExerciseId",
            key: "trainingExerciseId",
            render: (id) => <Tag color="volcano">#{id}</Tag>
        },
        {
            title: "Titre",
            dataIndex: "title",
            key: "title",
            render: (text) => <span style={{ fontWeight: "bold", color: "#722ed1" }}>📘 {text}</span>
        },
        {
            title: "Fichier modèle",
            dataIndex: "templateFileUrl",
            key: "templateFileUrl",
            render: (url) =>
                url ? (
                    <a href={url} target="_blank" rel="noopener noreferrer">
                        📥 <Tag color="blue">Modèle</Tag>
                    </a>
                ) : (
                    <Tag color="red">Aucun</Tag>
                )
        },
        {
    title: "Nb Réponses",
    dataIndex: "responses",
    key: "responses",
    render: (responses) => (
      <span className="font-semibold text-blue-600">
        {responses?.length || 0}
      </span>
    ),
  },
    ];



    const { Panel } = Collapse;


    return (
        // <Tabs tabPosition="right" defaultActiveKey="1" >
        <>
            <div style={{ textAlign: "right", marginBottom: 16 }}>
                <Button type="default" onClick={resetFormAndReload}>
                    🔄 Rafraîchir le formulaire
                </Button>
            </div>
            <Tabs
                tabPosition="right"
                activeKey={activeTabKey}
                onChange={(key) => setActiveTabKey(key)}
                ref={tabsRef}
            >


                <TabPane tab="➕ Nouvel entraînement" key="1">
                    {/* Ton formulaire existant */}
                    <>
                        <Form form={form} layout="vertical" onFinish={handleSubmit}>

                            <Form.Item
                                label="Titre de l'entraînement"
                                name="trainingTitle"
                                rules={[{ required: true, message: "Veuillez saisir le titre de l'entraînement" }]}
                            >
                                <Input placeholder="ex : Comprendre les bases du JavaScript" />
                            </Form.Item>
                            <Row gutter={16}>
                                <Col span={8}>
                                    <Form.Item
                                        name="elementType"
                                        label="Type d’élément"
                                        rules={[{ required: true }]}
                                    >
                                        <Select
                                            onChange={(value) => {
                                                form.setFieldValue("referenceElementId", undefined);
                                                setSelectedElementType(value);
                                                fetchElementsByType(value); // ⬅️ Lancer l’appel API uniquement si SUBJECT
                                            }}
                                        >
                                            <Select.Option value="SUBJECT">Sujet</Select.Option>
                                            <Select.Option value="TRAINING">Entraînement</Select.Option>
                                            {/* <Select.Option value="EVALUATION">Évaluation</Select.Option>
        <Select.Option value="CERTIFICATE">Certificat</Select.Option> */}
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col span={8}>
                                    <Form.Item
                                        name="referenceElementId"
                                        label="Insérer par rapport à l’élément"
                                        rules={[{ required: true }]}
                                    >
                                        <Select
                                            showSearch
                                            placeholder="Choisir un groupe"
                                            optionFilterProp="children"
                                            disabled={selectedElementType !== "SUBJECT"}
                                        >
                                            {courseElements.map((group) => (
                                                <Select.Option key={group.referenceId} value={group.referenceId}>
                                                    {group.label}
                                                </Select.Option>
                                            ))}
                                        </Select>
                                    </Form.Item>

                                </Col>

                                <Col span={8}>
                                    <Form.Item
                                        name="positioning"
                                        label="Positionner"
                                        rules={[{ required: true }]}
                                    >
                                        <Select>
                                            <Select.Option value="BEFORE">Avant</Select.Option>
                                            <Select.Option value="AFTER">Après</Select.Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            {/* 
                            <Form.Item
                                name="title"
                                label="Titre"
                                rules={[{ required: true, message: "Veuillez saisir un titre" }]}
                            >
                                <Input placeholder="Titre de l'exercice" />
                            </Form.Item>

                            <Form.Item
                                name="percentage"
                                label="Pourcentage"
                                rules={[
                                    { required: true, message: "Veuillez saisir un pourcentage" },
                                    {
                                        type: "number",
                                        min: 0,
                                        max: 100,
                                        message: "Le pourcentage doit être entre 0 et 100"
                                    }
                                ]}
                            >
                                <InputNumber placeholder="ex : 50" min={0} max={100} style={{ width: "100%" }} />
                            </Form.Item> */}

                            <Row gutter={16}>
                                <Col span={16}>
                                    <Form.Item
                                        name="title"
                                        label="Titre"
                                        rules={[{ required: true, message: "Veuillez saisir un titre" }]}
                                    >
                                        <Input placeholder="Titre de l'exercice" />
                                    </Form.Item>
                                </Col>

                                <Col span={8}>
                                    <Form.Item
                                        name="percentage"
                                        label="Pourcentage"
                                        rules={[
                                            { required: true, message: "Veuillez saisir un pourcentage" },
                                            {
                                                type: "number",
                                                min: 0,
                                                max: 100,
                                                message: "Le pourcentage doit être entre 0 et 100"
                                            }
                                        ]}
                                    >
                                        <InputNumber placeholder="ex : 50" min={0} max={100} style={{ width: "100%" }} />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Form.Item label="Instructions à suivre">
                                <Editor
                                    value={editorContent}
                                    init={{ height: 200, menubar: false }}
                                    onEditorChange={(content) => setEditorContent(content)}
                                />
                            </Form.Item>

                            <Form.Item label="Fichier à joindre">
                                <Upload
                                    beforeUpload={(file) => {
                                        setFile(file);
                                        return false;
                                    }}
                                    maxCount={1}
                                >
                                    <Button icon={<UploadOutlined />}>Choisir un fichier</Button>
                                </Upload>
                            </Form.Item>
                            {/* <Form.Item label="Fichier à joindre">
  <Upload
    beforeUpload={(file) => {
      setFile(file);
      return false;
    }}
    maxCount={1}
    disabled={!!editingExercise} // désactiver si édition
  >
    <Button icon={<UploadOutlined />} disabled={!!editingExercise}>
      Choisir un fichier
    </Button>
  </Upload>
  {editingExercise && (
    <Tag color="blue" style={{ marginTop: 8 }}>
      Modification activée – le fichier joint n’est pas modifiable.
    </Tag>
  )}
</Form.Item> */}


                            {/* <Form.Item>
                            <Button type="primary" htmlType="submit">
                                Enregistrer l'exercice
                            </Button>
                        </Form.Item> */}

                            <Form.Item>
                                <Button type="primary" htmlType="submit" loading={saving}>
                                    Enregistrer l'exercice
                                </Button>
                            </Form.Item>

                        </Form>

                        <h3>📋 Liste des exercices pour ce cours</h3>
                        {/* <Table
                            dataSource={trainings}
                            columns={columns}
                            rowKey="id"
                            loading={loading}
                            bordered
                            pagination={{ pageSize: 5 }}
                        /> */}
                        <Tabs defaultActiveKey="1">
                            <TabPane tab="📋 Réponses des étudiants" key="1">
                                <Table
                                    dataSource={transformedData}
                                    columns={columns}
                                    rowKey="id"
                                    loading={loading}
                                    bordered
                                    pagination={{ pageSize: 5, showSizeChanger: false }}
                                    style={{ background: "#fff", borderRadius: 8 }}
                                />
                            </TabPane>
                            <TabPane tab="📂 Exercices" key="2">
                                <Table
                                    dataSource={trainings}
                                    columns={columnsTrainings}
                                    rowKey="trainingExerciseId"
                                    loading={loading}
                                    bordered
                                    pagination={{ pageSize: 5, showSizeChanger: false }}
                                    style={{ background: "#fff", borderRadius: 8 }}
                                />
                            </TabPane>
                        </Tabs>


                    </>
                </TabPane>

                {/* <TabPane tab="📘 Liste des entraînements" key="2">
                        {structureLoading ? <p>Chargement des entraînements...</p> : renderTrainingList()}

                    {renderTrainingList()} */}
                {/* </TabPane> */}
                <TabPane tab="📘 Liste des entraînements" key="2">
                    {structureLoading ? <p>Chargement des entraînements...</p> : renderTrainingList()}
                </TabPane>



            </Tabs>
        </>
    );
};

export default TrainingForm;
